import React, {FC} from 'react'

import {observer} from 'mobx-react-lite'

import Select from '../Select'
import {ISelectProps} from '../Select/Select'

interface IMobxSelectProps extends ISelectProps {
	name: string
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	store: any
}

const MobxSelect: FC<IMobxSelectProps> = ({
	className,
	name,
	store,
	options,
	children,
	...props
}) => {
	return (
		<Select
			className={className}
			options={options}
			value={store[name]}
			name={name}
			onChange={(e) => {
				const value = e.target.value
				store[name] = value
			}}
			{...props}>
			{children}
		</Select>
	)
}

MobxSelect.displayName = 'MobxSelect'

export default observer(MobxSelect)
